window.comingsoon = (el) => {
    swal.fire({
        icon: 'info',
        title: 'Segera Hadir',
        text: 'Fitur masih dalam pengembangan'
    })
}
